var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notice.length > 0)?_c('div',{staticClass:"notice-wrapper"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('p',{key:_vm.scrollNum},[_vm._v(" "+_vm._s(_vm.notice[_vm.scrollNum])+" ")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }